export default {
  hero_label: 'Member',
  hero_title: 'Our Team',
  hero_subtitle: 'A team of professionals transforming Japan with AI.',
  members: [
    {
      id: 1,
      name: "Akihito Suzuki",
      nameEn: "Akihito Suzuki",
      position: "Representative Director & CEO",
      image: "/assets/member-suzuki.png",
      bio: "At a major enterprise, led business strategy and planning in AI and blockchain domains, serving as head of new services. Led business launches across multiple domains including IT consulting, system quality assurance, and talent/sales support as a business head and new business development consultant, achieving 200% growth across all businesses and contributing to business expansion. Founded AIX JAPAN based on early experience integrating AI into operations to drive results. A professional in AI × new business development with a relentless commitment to results and a track record across multiple domains.",
      career: [
        "2009 - Joined major strategic consulting firm",
        "2014 - Appointed Digital Strategy Department Manager",
        "2018 - Appointed Head of AI Solutions Business Division",
        "2021 - Founded AIX JAPAN"
      ]
    },
    {
      id: 2,
      name: "Gaku Fujita",
      nameEn: "Gaku Fujita",
      position: "AI Consultant",
      image: "/assets/member-fujita.png",
      bio: "After working at a major security SIer and as a creative director, now works as an AI consultant on client business automation. Active as a versatile generalist handling everything from creative to system development, tool implementation, and AI development. Specializes in AI consulting across diverse domains including security, manufacturing, infrastructure, and design. Joined AIX JAPAN in its early days.",
      career: [
        "2011 - Joined major SIer",
        "2015 - AI Solution Promotion Team Leader",
        "2019 - Head of AI Strategy Consulting Division",
        "2022 - Joined AIX JAPAN"
      ]
    },
    {
      id: 3,
      name: "Ryoma Nameki",
      nameEn: "Ryoma Nameki",
      position: "AI Consultant",
      image: "/assets/member-nameki.png",
      bio: "After graduating from Keio University, engaged in AI research, patents, and technical analysis. Investigates cutting-edge AI examples worldwide and supports a wide range of clients as an AI consultant. Excels at extracting new structures across the broad AI domain and integrating them into client businesses. Graduate of 42Tokyo, capable of programming and system construction. Completed AI training at the University of Tokyo's Matsuo Lab.",
      career: [
        "2010 - Joined talent development consulting firm",
        "2015 - AI Education Program Development Lead",
        "2019 - Launched corporate AI training business",
        "2022 - Joined AIX JAPAN"
      ]
    }
  ]
};